<template>
  <a :href="`/user/${item.username}`" class="tw-border-light-5 tw-border tw-relative tw-block" v-on:mouseenter="hovered = true" v-on:mouseleave="hovered = false">
    <div class="tw-relative">
      <div style="padding-top: 75%;"></div>
      <img :src="item.display_avatar" class="tw-absolute tw-top-0 tw-h-full tw-left-0 tw-w-full tw-object-cover"/>
      <div class="tw-absolute tw-left-0 tw-top-0 tw-ml-2 tw-mt-2 tw-flex flex-center">
        <svg class="tw-w-20 tw-h-20 tw-text-red tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);-ms-filter:">
          <path d="M19.965,8.521C19.988,8.347,20,8.173,20,8c0-2.379-2.143-4.288-4.521-3.965C14.786,2.802,13.466,2,12,2 S9.214,2.802,8.521,4.035C6.138,3.712,4,5.621,4,8c0,0.173,0.012,0.347,0.035,0.521C2.802,9.215,2,10.535,2,12 s0.802,2.785,2.035,3.479C4.012,15.653,4,15.827,4,16c0,2.379,2.138,4.283,4.521,3.965C9.214,21.198,10.534,22,12,22 s2.786-0.802,3.479-2.035C17.857,20.283,20,18.379,20,16c0-0.173-0.012-0.347-0.035-0.521C21.198,14.785,22,13.465,22,12 S21.198,9.215,19.965,8.521z"></path>
        </svg>
        <div class="tw-absolute tw-left-50pc tw-top-50pc tw-text-light tw-font-extrabold tw-transform tw--translate-x-1/2 tw--translate-y-1/2">
          {{parseInt(item.max_discount)}}%
        </div>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-4 tw--mx-2 tw-p-4 tw-gap-4">
      <div class="tw-col-span-4 tw-space-x-2 tw--mx-4 tw-px-4 tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex flex-center tw-space-x-1 tw-max-w-1/2">
          <i class="bx bxs-map tw-text-3xl tw-text-secondary"></i>
          <div class="tw-font-semibold tw-text-lg tw-text-dark tw-text-opacity-75 tw-truncate">{{item.suburb_name}}</div>
        </div>
        <!--<div class="tw-h-5 tw-w-px tw-bg-light-8"></div>-->
        <div class="tw-flex flex-center tw-space-x-1 tw-max-w-1/2">
          <i class="bx bxs-category tw-text-3xl tw-text-secondary"></i>
          <div class="tw-font-semibold tw-text-lg tw-text-dark tw-text-opacity-75 tw-truncate">{{item.category_name}}</div>
        </div>
      </div>
      <div class="tw-col-span-4 tw-text-3xl tw-font-semibold tw-py-1 tw-text-center">
        {{item.display_name}}
      </div>
    </div>
    <div class="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-bg-light tw-bg-opacity-90" v-show="hovered">
      <div class=" tw-p-6 tw-gap-6 tw-grid">
        <div>
          <span class="tw-inline-block tw-bg-red tw-text-light tw-font-semibold tw-px-2 tw-rounded">{{parseInt(item.max_discount)}}%</span>
          <span class="tw-font-semibold">{{item.product_title}}</span>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
  export default {
    props : {
      item:{}
    },
    data : v => ({
      hovered : false,
    })
  }
</script>
